import { Router } from "@solidjs/router";
import { render } from "solid-js/web";
import { App } from "./App.tsx";
import { AuthProvider } from "./auth/AuthContext.tsx";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root mount point");

render(
  () => <Router root={(props) => <AuthProvider>{props.children}</AuthProvider>}>{App()}</Router>,
  root,
);
